import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '../utils/cn';

export const ModifyBooking = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="ModifyBookingIcon"
			width="161"
			height="160"
			viewBox="0 0 161 160"
			fill="none"
			{...props}
		>
			<path
				d="M107.789 65.1098C109.169 65.1098 110.289 63.9896 110.289 62.6077C110.289 61.2258 109.169 60.1056 107.789 60.1056L52.8065 60.0124C51.4258 60.0124 50.3065 61.1326 50.3065 62.5145C50.3065 63.8964 51.4258 65.0166 52.8065 65.0166L107.789 65.1098Z"
				fill="#0770E4"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M59.3316 34.5021C59.3316 33.1202 58.2123 32 56.8316 32C55.4509 32 54.3316 33.1202 54.3316 34.5021L54.3352 37.8668L43.5 37.8668C34.6634 37.8668 27.5 45.0363 27.5 53.8803V105.987C27.5 114.831 34.6634 122 43.5 122L117.5 122C126.337 122 133.5 114.831 133.5 105.987V53.8803C133.5 45.0363 126.337 37.8668 117.5 37.8668L106.073 37.8668L106.069 34.5021C106.069 33.1202 104.95 32 103.569 32C102.188 32 101.069 33.1202 101.069 34.5021L101.073 37.8668L59.3352 37.8668L59.3316 34.5021ZM101.073 44.4405V42.871L59.3352 42.871V44.4405C59.3352 45.8224 58.216 46.9426 56.8352 46.9426C55.4545 46.9426 54.3352 45.8224 54.3352 44.4405V42.871H43.5C37.4249 42.871 32.5 47.8001 32.5 53.8803L32.5 105.987C32.5 112.067 37.4249 116.996 43.5 116.996L117.5 116.996C123.575 116.996 128.5 112.067 128.5 105.987V53.8803C128.5 47.8001 123.575 42.871 117.5 42.871H106.073V44.4405C106.073 45.8224 104.954 46.9426 103.573 46.9426C102.192 46.9426 101.073 45.8224 101.073 44.4405Z"
				fill="#0770E4"
			/>
			<path
				d="M102.251 91.0557C106.811 91.0557 110.5 87.3637 110.5 82.8058C110.5 78.2479 106.811 74.5559 102.251 74.5559C97.6911 74.5559 94.0019 78.2479 94.0019 82.8058C94.0019 87.3637 97.6911 91.0557 102.251 91.0557Z"
				fill="#FC790D"
			/>
		</SvgIcon>
	);
};

export default ModifyBooking;
